import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import WeatherData from './views/WeatherData.vue'

const routes = [
  {
    path: '/weather',
    component: WeatherData,
    name: 'WeatherData'
  },
  {
    path: '/',
    component: Home,
    name: 'Home'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
